/*
 * Copyright (c) 2026.
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden volgens de voorwaarden die zijn vastgelegd in een bijbehorende schriftelijke overeenkomst met Spin in het Web B.V.
 */

/**
 * Auteur: Jelmer Jellema - Spin in het Web B.V.
 * Gegenereerd met Junie (AI), 26-05-2026
 *
 * Angular modal-component voor de startup-popup.
 * Vervangt de inline AngularJS $uibModal in standaardStartup() van cytocanvas.controller.js.
 */

import { Component } from '@angular/core';
import { BaseIslandComponent } from '../../base-island.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { inject } from '@angular/core';
import type { StartupPopupProjectdata, StartupPopupUserdata } from './startup-popup.types';

@Component({
    selector: 'dl-startup-popup',
    standalone: true,
    imports: [CommonModule, TranslateModule],
    templateUrl: './dl-startup-popup.component.html',
    styleUrls: ['./dl-startup-popup.component.scss']
})
export class DlStartupPopupComponent extends BaseIslandComponent {

    /** Projectdata meegegeven via BsModalService initialState */
    projectdata!: StartupPopupProjectdata;

    /** Userdata meegegeven via BsModalService initialState */
    userdata!: StartupPopupUserdata;

    /** Callback voor de video-knop */
    onStartvideo!: () => void;

    /** Callback voor de model-openen-knop */
    onOpenmodel!: () => void;

    /** Callback voor de standaardmodel-knop */
    onStandaardmodel!: () => void;

    private readonly modalRef = inject(BsModalRef);

    constructor() { super(); }

    /** Sluit de modal en roept de startvideo-callback aan */
    startvideo(): void {
        this.modalRef.hide();
        this.onStartvideo();
    }

    /** Sluit de modal en roept de openmodel-callback aan */
    openmodel(): void {
        this.modalRef.hide();
        this.onOpenmodel();
    }

    /** Sluit de modal en roept de standaardmodel-callback aan */
    standaardmodel(): void {
        this.modalRef.hide();
        this.onStandaardmodel();
    }
}
